import React, {useRef, useState, useEffect} from "react";
import {Card, FormGroup, Input, InputGroup} from "reactstrap";
import OtpInput from "react-otp-input";
import {useDispatch} from "react-redux";
import {useNavigate} from "react-router-dom";
import {useSelector} from "react-redux";
import DarkBg from "../../assets/img/background_img/zeus_bg.jpg";
import zeusLogo from "../../assets/img/brand/zeus_logo.png";
import ZeusButton from "../../components/Button";
import {
  requestOrganization,
  requestOrganizationImages,
} from "../../redux/Actions/root.actions";
import {getOrganizationImages} from "../../redux/Selectors/root.selector";
import {requestOTP, validateOTP} from "../../redux/Actions/login.actions";
import CookieService from "../../service/cookieService";
import "./styles.scss";

const ACTIONS = {
  1: "Get OTP",
  2: "Validate OTP",
};

const Login = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const intervalRef = useRef();
  const [authOject, setAuthObject] = useState({email: ""});
  const [action, setAction] = useState(1);
  const [timer, setTimer] = useState(0);
  const {backgroundImg, background_type, logoImg} = useSelector(getOrganizationImages);

  const clearTimeInterval = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
    }
  };

  useEffect(() => {
    dispatch(requestOrganizationImages());
    return clearTimeInterval;
  }, [dispatch]);

  const handleRequestOTP = () => {
    setTimer(0);
    clearTimeInterval();
    const callback = () => {
      setAction(2);
      intervalRef.current = setInterval(() => setTimer((prevTime) => prevTime + 1), 1000);
    };

    dispatch(requestOTP({email: authOject.email}, callback));
  };

  const handleValidateOTP = () => {
    const callback = (data) => {
      CookieService().setAppToken(data.data, authOject.rememberMe);
      navigate("/app/home");
      dispatch(requestOrganization());
      //setting customer in localStorage to current customer if value available in session storage
      if (
        JSON.stringify(
          JSON.parse(JSON.parse(sessionStorage.getItem("persist:root"))?.customers)
            ?.selectedCustomer
        )
      ) {
        localStorage.setItem(
          "customer",
          JSON.stringify(
            JSON.parse(JSON.parse(sessionStorage.getItem("persist:root"))?.customers)
              .selectedCustomer
          )
        );
      }
    };

    dispatch(validateOTP(authOject, callback));
  };

  const handleEvent = () => {
    if (action === 1) {
      handleRequestOTP();
    } else if (action === 2) {
      handleValidateOTP();
    }
  };

  const handleEventName = () => ACTIONS[action];

  const handleKeyDown = (event) => {
    if (event.keyCode === 13) {
      handleRequestOTP();
    }
  };

  return (
    <div className="login-page">
      {background_type === "video" ? (
        <video autoPlay loop muted playsInline className="bg-media">
          <source src={backgroundImg} />
        </video>
      ) : (
        <div
          className="bg-media"
          style={{
            backgroundImage: backgroundImg ? `url(${backgroundImg})` : `url(${DarkBg})`,
          }}
        />
      )}
      <div className="logoContainer">
        <img src={logoImg || zeusLogo} alt="Organisation Logo" className="logoImage" />
      </div>
      <Card className={`login_container ${action === 2 ? "otp-mode" : ""}`}>
        <p className="form_header">Login to your account</p>
        <div className={`form_block ${action === 2 ? "otp-mode" : ""}`}>
          {action === 1 && (
            <FormGroup className="input_box">
              <label htmlFor="email" className="form-label">
                Email
              </label>
              <InputGroup className="input-group-alternative">
                <Input
                  placeholder="Enter email address"
                  type="email"
                  id={"email"}
                  autoComplete="new-email"
                  // value={authOject.email}
                  onChange={(e) =>
                    setAuthObject({
                      ...authOject,
                      email: e.target.value,
                    })
                  }
                  onKeyDown={handleKeyDown}
                  // eslint-disable-next-line jsx-a11y/no-autofocus
                  autoFocus={true}
                />
              </InputGroup>
            </FormGroup>
          )}
          {action === 2 && (
            <FormGroup className="otp-container">
              <OtpInput
                containerStyle={"otp"}
                inputStyle={"otpInput"}
                inputType={"tel"}
                numInputs={6}
                onChange={(e) =>
                  setAuthObject({
                    ...authOject,
                    token: e,
                  })
                }
                renderInput={(props) => <input data-cy={"cy-otp"} {...props} />}
                shouldAutoFocus
                value={authOject.token}
              />

              <div className="custom-control custom-control-alternative custom-checkbox">
                <input
                  className="custom-control-input"
                  id="customCheckLogin"
                  type="checkbox"
                  data-cy={"remember-me-check"}
                  onChange={(e) =>
                    setAuthObject({
                      ...authOject,
                      rememberMe: e.target.value === "on",
                    })
                  }
                />
                <label className="custom-control-label" htmlFor="customCheckLogin">
                  <span className="text-muted">Remember me</span>
                </label>
              </div>
            </FormGroup>
          )}
          <div className="d-flex submit-block">
            <ZeusButton
              data-cy="submit-btn"
              onClick={handleEvent}
              classes="submit-btn"
              withRadius
              withShadow
            >
              {handleEventName()}
            </ZeusButton>
            {action === 2 && (
              <ZeusButton
                type="info-small"
                onClick={handleRequestOTP}
                disabled={timer <= 20}
                data-cy="resend-btn"
              >
                {`Resend OTP ${timer <= 20 ? 20 - timer : ""}`}
              </ZeusButton>
            )}
          </div>
        </div>
      </Card>
      <div className="policy-text">
        By clicking continue you agree to our{" "}
        <a
          href="https://www.energyresourceproducts.com/servicepolicy"
          target="_blank"
          rel="noreferrer"
        >
          Terms Of Service
        </a>{" "}
        and{" "}
        <a
          href="https://www.energyresourceproducts.com/privacypolicy"
          target="_blank"
          rel="noreferrer"
        >
          Privacy Policy
        </a>
        .
      </div>
    </div>
  );
};

export default Login;
